export function FeatureFlagService($q, $rootScope, $location, restaurantInfoFactory) {
    'ngInject';

    let _initDfd;
    let service = {
        data: {
            features: new Set()
        },
        flagEnabled,
        getInitialized
    };
    _init();
    return service;

    ///---------------------------------------------

    function _init() {
        _initDfd = $q.defer();
        _getRestaurantFeatures()
            .then(
                () => _initDfd.resolve(),
                error => _initDfd.reject(error)
            )
            .then(_startWatching);
    }

    function _getRestaurantFeatures() {
        return restaurantInfoFactory.getInfo(['features'])
            .then(info => service.data.features = new Set(info.features));
    }

    function _startWatching() {
        $rootScope.$watchCollection(() => $location.search().fflags, _updateFeatureFlags);
    }

    function _updateFeatureFlags(flagString) {
        let queryFlags = typeof flagString === 'string' ? new Set(flagString.split(',')) : new Set();
        _getRestaurantFeatures().then(() => {
            let newSet = new Set(service.data.features);
            for (const flag of queryFlags) {
                newSet.add(flag);
            }
            service.data.features = newSet;
        });
    }

    /**
     * @return {Promise<void>} a promise that will resolve once the feature flag service has initialized
     */
    function getInitialized() {
        return _initDfd.promise;
    }

    function flagEnabled(flagString) {
        return service.data.features.has(flagString);
    }
}
